import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

import { useCartRedux } from '@hooks'
import cartIcon from '../../assets/images/icons/ic_Cart.png'
import CartContent from './CartContent'
import CartHeader from './CartHeader'
import CartFooter from './CartFooter'

const CartModal = ({ isOpen, onOpen, onClose }) => {
    const { items } = useCartRedux()
    const [animate, setAnimate] = useState(false)

    useEffect(() => {
        if (items.length > 0) {
            setAnimate(true)
            setTimeout(() => setAnimate(false), 500)
        }
    }, [items.length])

    return (
        <>
            <Button className={`cart-modal-button ${animate ? 'cart-animate' : ''}`} onClick={onOpen} color="white">
                <img className="cart-modal-img" alt="cart" src={cartIcon} />
                {items.length > 0 && <span className="cart-badge">{items.length}</span>}
            </Button>

            <Modal isOpen={isOpen} toggle={onClose} fullscreen="lg" centered>
                <ModalHeader toggle={onClose} className="custom-modal-header">
                    Cart Items
                </ModalHeader>
                <ModalBody className="cart-modal-body">
                    <CartHeader />
                    <div className="hide-scrollbar">
                        <CartContent />
                    </div>
                </ModalBody>
                <CartFooter />
            </Modal>
        </>
    )
}

export default CartModal
